'use strict';

import angular from 'angular';

function MemberAttributeTypeResource($resource) {
  return $resource('/api/groups/:groupId/memberattributetypes/:id/:controller',
    {
      id: '@id'
    }, {
      getDefinedBy: {
        method: 'GET',
        isArray: true,
        params: { controller: 'definedby' }
      },
      getDefinedFor: {
        method: 'GET',
        isArray: true
      },
      getOptions: {
        method: 'GET',
        isArray: true,
        params: { controller: 'options' }
      },
      create: { method: 'POST' },
      update: { method: 'PUT' }
    });
}

MemberAttributeTypeResource.$inject = ['$resource'];

export default angular.module('georgeApp.memberAttributeTypeSvc', [])
  .factory('MemAtrTypeSvc', MemberAttributeTypeResource)
  .name;
